import {
  EMPTY_QUERY,
  SORT_FIELD,
  SORT_DIRECTION,
} from '@/checkout-instore-legacy/constants/SearchConstants'
import {
  FIRST_PAGE,
  PAGE_SIZE,
} from '@/checkout-instore-legacy/constants/ProductSuggestionsConstants'
import { CACHE_STRATEGIES } from '@/checkout-instore-legacy/constants/CacheConstants'
import { FilterSearchAttribute } from '@/checkout-instore-legacy/search/typings'

import { isSearchCacheValid } from '@/checkout-instore-legacy/search/utils'

import {
  CacheStrategy,
  findProductsByTerm,
  findProductsByTermWithSimulation,
} from '@/checkout-instore-legacy/services/CatalogService'

import * as thisModule from './service'

export interface SortMethod {
  field: string
  direction: string
}

export async function getProductSuggestions(
  sort: SortMethod,
  simulationAddress: Address
) {
  const term = EMPTY_QUERY
  const page = FIRST_PAGE
  const postalCode = simulationAddress.postalCode || ''
  const filters: FilterSearchAttribute[] = []
  const pageSize = PAGE_SIZE

  const isCacheValid = await isSearchCacheValid(
    term,
    filters,
    postalCode,
    page,
    sort,
    pageSize
  )

  const cacheStrategy: CacheStrategy = isCacheValid
    ? (CACHE_STRATEGIES.CACHE_FIRST as CacheStrategy)
    : undefined

  const findProductsByTermPromise = async () =>
    await findProductsByTerm({
      term,
      postalCode,
      attributes: filters,
      sort,
      pageSize,
      cacheStrategy,
    })

  const findProductsByTermWithSimulationPromise = async () =>
    await findProductsByTermWithSimulation(
      {
        term,
        postalCode,
        attributes: filters,
        sort,
        pageSize,
        cacheStrategy,
      },
      simulationAddress
    )

  const result = await Promise.all([
    findProductsByTermPromise(),
    findProductsByTermWithSimulationPromise(),
  ])

  return result[1].products
}

export async function getBestSellers(
  simulationAddress: Address
): Promise<Product[]> {
  const sort: SortMethod = {
    field: SORT_FIELD.ORDERS,
    direction: SORT_DIRECTION.DESC,
  }

  return await thisModule.getProductSuggestions(sort, simulationAddress)
}

export async function getPromotions(
  simulationAddress: Address
): Promise<Product[]> {
  const sort: SortMethod = {
    field: SORT_FIELD.DISCOUNT,
    direction: SORT_DIRECTION.DESC,
  }

  return await thisModule.getProductSuggestions(sort, simulationAddress)
}
